import { render, staticRenderFns } from "./usens.vue?vue&type=template&id=4c0e2668&scoped=true"
import script from "./usens.vue?vue&type=script&lang=js"
export * from "./usens.vue?vue&type=script&lang=js"
import style0 from "./usens.vue?vue&type=style&index=0&id=4c0e2668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e2668",
  null
  
)

export default component.exports